var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table__container" },
    [
      _c(
        "el-table",
        {
          class: _vm.additionalClasses,
          staticStyle: { width: "100%" },
          attrs: {
            id: "schedulesTable",
            data: _vm.tableData,
            "max-height": "485",
            "header-cell-class-name": _vm.headerCellClassName,
            "cell-class-name": _vm.cellClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("schedules-table-cell", {
                      attrs: { "cell-data": scope.row, type: "name" },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "frequency", label: "Frequency" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("schedules-table-cell", {
                      attrs: { "cell-data": scope.row, type: "frequency" },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accessPeriod", label: "Access Period" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("schedules-table-cell", {
                      attrs: { "cell-data": scope.row, type: "accessPeriod" },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("template", { slot: "empty" }, [
            _c(
              "div",
              {
                staticClass:
                  "no-records__container body__large-regular__secondary",
              },
              [_vm._v("\n        " + _vm._s(_vm.emptyMessage) + "\n      ")]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isAccountVerificationRequired
        ? _c("account-verification-message", {
            attrs: { "device-name": _vm.deviceName },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }